// extracted by mini-css-extract-plugin
module.exports = {"card":"airmileinfo_card__UhPt7","cardHeader":"airmileinfo_cardHeader__EaxwQ"};